import { atom } from 'jotai';
import type { AuctionFormData } from '@/types/auction';
import type { ValidationError } from '@/types/apiTypes';

export const showSaveAsTemplateModalAtom = atom(false);

export const pendingTemplateDataAtom = atom<AuctionFormData | null>(null);

/**
 * Name of the auction a template is being saved *from* (landing-page "Save as template"
 * flow, WBPR-4123). When set, the modal shows a "Saving from: <name>" context line. Left
 * `null` by the Auction Create/Edit form flow, so that path renders unchanged.
 */
export const templateSourceAuctionNameAtom = atom<string | null>(null);

/** Set by the modal when a 422 is returned; consumed by the parent form via useEffect. */
export const templateValidationErrorsAtom = atom<ValidationError[] | null>(null);

/**
 * Incremented by the modal on every successful template save. The parent form watches
 * this value and calls clearErrors() + resets its local error state when it changes,
 * ensuring that any RHF field errors previously set by template validation are removed.
 */
export const templateSaveSuccessCountAtom = atom(0);
